import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-12">
          焦点专题
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselData.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group block bg-background-100 rounded-2xl overflow-hidden hover:scale-[1.01] transition-transform duration-300 cursor-pointer"
            >
              <div className="relative aspect-[5/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {item.accent && (
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full">
                      推荐
                    </span>
                  </div>
                )}
              </div>
              <div className="p-5">
                <h3 className="text-sm font-semibold text-foreground-950 leading-snug mb-2 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}